import(/* webpackMode: "eager", webpackExports: ["FooterAddress"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\app\\layouts\\Share\\Footer\\FooterAddress\\FooterAddress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\app\\layouts\\Share\\Header\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\app\\layouts\\Share\\MobileNav\\MobileNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\components\\ui\\BgSection\\BackgroundLayout.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\node_modules\\next\\dist\\client\\link.js");
